import { AxiosInstance } from "axios";
import { createAsyncThunk } from "@reduxjs/toolkit";

import { CheckListMethodDelete } from "components/sliderPage/manageWallet/deleteConfirmation/DeleteConfirmation";
import * as requestUrl from "../../constants/request";
import { PaymentMethod } from "./paymentMethods-state";
import { tryConvertToProblemDetails } from "utility/errors";

export type FetchPaymentMethods = typeof fetchPaymentMethods;

export const fetchPaymentMethods = createAsyncThunk<
  PaymentMethod[],
  {
    request: AxiosInstance;
  }
>("paymentMethods/fetchPaymentMethods", async ({ request }, thunkAPI) => {
  const response = await request(requestUrl.FT_PAYMENT_METHODS);
  return response.data;
});

export type SavePaymentMethod = typeof savePaymentMethod;

export const savePaymentMethod = createAsyncThunk<
  PaymentMethod,
  {
    request: AxiosInstance;
    data: PaymentMethod;
  }
>("paymentMethods/savePaymentMethod", async ({ request, data }, thunkAPI) => {
  try {
    const response = await request(
      requestUrl.FT_ADD_PAYMENT_METHOD,
      {
        method: "POST",
        data
      }
    );
    return response.data;
  } catch (e) {
    const error = tryConvertToProblemDetails(e);
    return thunkAPI.rejectWithValue(error);
  }
});

export type DeletePaymentMethods = typeof deletePaymentMethods;

export const deletePaymentMethods = createAsyncThunk<
  number,
  {
    request: AxiosInstance;
    data: number;
  }
>("paymentMethods/deletePaymentMethods", async ({ request, data: id }) => {
  await request(`${requestUrl.FT_ADD_PAYMENT_METHOD}/${id}`, {
    method: "DELETE",
  });
  return id;
});

export const deletePaymentMethodWithLink = createAsyncThunk<
  any,
  {
    request: AxiosInstance;
    data: CheckListMethodDelete;
  }
>(
  "paymentMethods/deletePaymentMethodWithLink",
  async ({ request, data: checkList }, thunkAPI) => {
    const promiseToResolveHolder: any = [];
    if (checkList.isAutoPayLinked) {
      promiseToResolveHolder.push(
        request(`${requestUrl.FT_AUTO_PAY}/${checkList.autoPayData?.id}`, {
          method: "DELETE",
        })
      );
    }
    if (checkList.isScheduleLinked) {
      checkList.schedulePayments?.forEach((single) => {
        if (!single.recurrenceScheduleId)
          promiseToResolveHolder.push(
            request(requestUrl.FT_SCHEDULE_PAYMENT, {
              method: "PUT",
              data: { ...single, status: 1 },
            })
          );
      });
    }
    const response = await Promise.all(promiseToResolveHolder);
    return response;
  }
);
